type Environment = 'development' | 'staging' | 'qa' | 'production' | 'pcoms'

export const CSPConfig = {
  development: `
        default-src 'self';
        script-src 'self' 'unsafe-eval' https://unpkg.com https://cdn.jsdelivr.net;
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;
        img-src 'self' data: https: blob:;
        font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com;
        connect-src 'self'
            wss://transcribestreaming.us-east-1.amazonaws.com:8443
            https://cdn.jsdelivr.net
            http://localhost:4001//status
            http://localhost:4001/graphql
            https://*.launchdarkly.com
            https://at-graph-s.medgeo.com/graphql
            https://api-s.medgeo.com
            https://inventory-s.medgeo.com
            https://reports-s.medgeo.com
            https://reports-q.medgeo.com
            https://hio0vzvmzc.execute-api.us-east-1.amazonaws.com
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING/api/process_image
            https://medgeo-staging.us.auth0.com
            https://o4504499096780800.ingest.sentry.io
            https://httpbin.org
            https://mgat-media-staging.s3.us-east-1.amazonaws.com
            https://dtm-analysis-results.s3.us-east-1.amazonaws.com
            https://lottie.host
            https://gudid.medgeo.com/api/v2/
            https://better-id-s.medgeo.com/
            https://betterid-general-stg.s3.us-east-1.amazonaws.com/product-requests/organizations/MedGEO/
            https://gudid.medgeo.com/api/v2/
            https://at-graph-qa.medgeo.com/graphql
            https://e-wallet-s.medgeo.com/;
        frame-src 'self' blob: https://medgeo-staging.us.auth0.com https://dtm-analysis-results.s3.us-east-1.amazonaws.com https://analytics-stg.medgeo.com https://catalog-stg.medgeo.com;
        object-src 'self' data: https://dtm-analysis-results.s3.us-east-1.amazonaws.com;
        worker-src 'self' blob:;
        wasm-src 'self' https://cdn.jsdelivr.net;
        child-src 'self' blob:;
        media-src 'self' blob:;
    `,
  qa: `
        default-src 'self';
        script-src 'self' 'unsafe-eval' https://unpkg.com https://cdn.jsdelivr.net;
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;
        img-src 'self' data: https: blob:;
        font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com;
        connect-src 'self'
            wss://transcribestreaming.us-east-1.amazonaws.com:8443
            https://cdn.jsdelivr.net
            https://api-s.medgeo.com/status
            https://*.launchdarkly.com
            https://at-graph-qa.medgeo.com/graphql
            https://at-graph-qa.medgeo.com
            https://at-graph-s.medgeo.com
            https://api-s.medgeo.com
            https://inventory-qa.medgeo.com/graphql
            https://inventory-qa.medgeo.com
            https://reports-q.medgeo.com/
            https://analytics-qa.medgeo.com
            https://hio0vzvmzc.execute-api.us-east-1.amazonaws.com
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING/api/process_image
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING/api/tray-templates
            https://medgeo-staging.us.auth0.com
            https://medgeo-staging.us.auth0.com/api/v2/
            https://at-s.medgeo.com/
            https://o4504499096780800.ingest.sentry.io
            https://552b6c70e8674dc3aafd150e74588745@o4504499096780800.ingest.sentry.io
            https://httpbin.org
            https://mgat-media-staging.s3.us-east-1.amazonaws.com
            https://dtm-analysis-results.s3.us-east-1.amazonaws.com
            https://lottie.host
            https://gudid.medgeo.com/api/v2/
            https://better-id-s.medgeo.com/
            https://betterid-general-stg.s3.us-east-1.amazonaws.com/product-requests/organizations/MedGEO/
            https://e-wallet-qa.medgeo.com/;
        frame-src 'self' blob: https://medgeo-staging.us.auth0.com https://dtm-analysis-results.s3.us-east-1.amazonaws.com https://analytics-qa.medgeo.com https://catalog-qa.medgeo.com;
        object-src 'self' data: https://dtm-analysis-results.s3.us-east-1.amazonaws.com;
        worker-src 'self' blob:;
        wasm-src 'self' https://cdn.jsdelivr.net;
        child-src 'self' blob:;
        media-src 'self' blob:;
    `,
  staging: `
        default-src 'self';
        script-src 'self' 'unsafe-eval' https://unpkg.com https://cdn.jsdelivr.net;
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;
        img-src 'self' data: https: blob:;
        font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com;
        connect-src 'self'
            wss://transcribestreaming.us-east-1.amazonaws.com:8443
            https://cdn.jsdelivr.net
            https://api-s.medgeo.com/status
            https://*.launchdarkly.com
            https://at-graph-qa.medgeo.com/graphql
            https://at-graph-qa.medgeo.com
            https://api-s.medgeo.com
            https://inventory-qa.medgeo.com/graphql
            https://inventory-qa.medgeo.com
            https://reports-q.medgeo.com/
            https://analytics-qa.medgeo.com
            https://hio0vzvmzc.execute-api.us-east-1.amazonaws.com
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING/api/process_image
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING/api/tray-templates
            https://medgeo-staging.us.auth0.com
            https://medgeo-staging.us.auth0.com/api/v2/
            https://o4504499096780800.ingest.sentry.io
            https://552b6c70e8674dc3aafd150e74588745@o4504499096780800.ingest.sentry.io
            https://httpbin.org
            https://mgat-media-staging.s3.us-east-1.amazonaws.com
            https://dtm-analysis-results.s3.us-east-1.amazonaws.com
            https://lottie.host
            https://gudid.medgeo.com/api/v2/
            https://better-id-s.medgeo.com/
            https://betterid-general-stg.s3.us-east-1.amazonaws.com/product-requests/organizations/MedGEO/
            https://e-wallet-qa.medgeo.com/;
        frame-src 'self' blob: https://medgeo-staging.us.auth0.com https://dtm-analysis-results.s3.us-east-1.amazonaws.com https://analytics-qa.medgeo.com https://catalog-qa.medgeo.com;
        object-src 'self' data: https://dtm-analysis-results.s3.us-east-1.amazonaws.com;
        worker-src 'self' blob:;
        wasm-src 'self' https://cdn.jsdelivr.net;
        child-src 'self' blob:;
        media-src 'self' blob:;
    `,
  production: `
        default-src 'self';
        script-src 'self' 'unsafe-eval' https://unpkg.com https://cdn.jsdelivr.net;
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;
        img-src 'self' data: https: blob:;
        font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com;
        connect-src 'self'
            wss://transcribestreaming.us-east-1.amazonaws.com:8443
            https://cdn.jsdelivr.net
            https://api.medgeo.com/status
            https://*.launchdarkly.com
            https://at-graph.medgeo.com/graphql
            https://api.medgeo.com
            https://inventory.medgeo.com
            https://reports.medgeo.com
            https://hio0vzvmzc.execute-api.us-east-1.amazonaws.com
            https://hio0vzvmzc.execute-api.us-east-1.amazonaws.com/PROD/api/process_image
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING/api/process_image
            https://7rmvx8i1ek.execute-api.us-east-1.amazonaws.com/STAGING/api/tray-templates
            https://medgeo.us.auth0.com
            https://o4504499096780800.ingest.sentry.io
            https://o4504408301436928.ingest.sentry.io
            https://httpbin.org
            https://mgat-media.s3.us-east-1.amazonaws.com
            https://dtm-analysis-results.s3.us-east-1.amazonaws.com
            https://lottie.host
            https://gudid.medgeo.com/api/v2/
            https://better-id.medgeo.com/
            https://betterid-general-prod.s3.us-east-1.amazonaws.com/product-requests/organizations/ 
            https://gudid.medgeo.com/api/v2/
            https://e-wallet.medgeo.com/;
        frame-src 'self' blob: https://medgeo.us.auth0.com https://medgeo-staging.us.auth0.com https://dtm-analysis-results.s3.us-east-1.amazonaws.com https://analytics.medgeo.com https://catalog.medgeo.com https://analytics-stg.medgeo.com https://catalog-stg.medgeo.com;
        object-src 'self' data: https://dtm-analysis-results.s3.us-east-1.amazonaws.com;
        worker-src 'self' blob:;
        wasm-src 'self' https://cdn.jsdelivr.net;
        child-src 'self' blob:;
        media-src 'self' blob:;
    `,
  pcoms: `
        default-src 'self';
        script-src 'self' 'unsafe-eval' https://unpkg.com https://cdn.jsdelivr.net;
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;
        img-src 'self' data: https: blob:;
        font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com;
        connect-src 'self'
            wss://transcribestreaming.us-east-1.amazonaws.com:8443
            https://cdn.jsdelivr.net
            https://api.medgeo.com/status
            https://*.launchdarkly.com
            https://at-graph-pcoms.medgeo.com/graphql
            https://api-pcoms.medgeo.com
            https://inventory-pcoms.medgeo.com
            https://reports-pcom.medgeo.com
            https://hio0vzvmzc.execute-api.us-east-1.amazonaws.com
            https://medgeo.us.auth0.com
            https://o4504499096780800.ingest.sentry.io
            https://o4504408301436928.ingest.sentry.io
            https://httpbin.org
            https://mgat-media.s3.us-east-1.amazonaws.com
            https://dtm-analysis-results.s3.us-east-1.amazonaws.com
            https://lottie.host
            https://gudid.medgeo.com/api/v2/
            https://better-id.medgeo.com/
            https://betterid-general-prod.s3.us-east-1.amazonaws.com/product-requests/organizations/
            https://gudid.medgeo.com/api/v2/
            https://e-wallet.medgeo.com/;
        frame-src 'self' blob: https://analytics.medgeo.com https://catalog.medgeo.com
            https://medgeo.us.auth0.com;
        object-src 'none';
        worker-src 'self' blob:;
        wasm-src 'self' https://cdn.jsdelivr.net;
        child-src 'self' blob:;
        media-src 'self' blob:;
    `,
}

export const getCSPContent = (): string => {
  const env = process.env.REACT_APP_ENV as Environment
  return CSPConfig[env]
}
